import React from "react";
import { IconProps } from "../icon";

export const Italic_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.25 4l-6 16m9.5-16l-6 16M19.5 4h-10m5 16h-10"
    />
  </svg>
);
